module.exports = __webpack_public_path__ + "img/default-agency.a09e6c16.png";